import SpriteSymbol from "../../../../../../../sfra-webpack-builder/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../sfra-webpack-builder/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"error\"><path d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10Zm1.2-17.771H8.8l.457 10.057h1.486L11.2 2.229Zm.038 12.857c0-.686-.552-1.238-1.238-1.238-.686 0-1.238.552-1.238 1.238A1.24 1.24 0 0 0 10 16.343a1.24 1.24 0 0 0 1.238-1.257Z\" fill=\"#D22030\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol